import React, { useEffect, useState } from 'react'
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import TableVerticalExperience from './TableVerticalExperience';
import { startRegisterCompareResult } from '../../app/actions/compareResultActions';

const ComparisonContainerExperienceByField = () => {

  debugLogPages(':: ComparisonContainerExperienceByField');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { experiencesS } = useSelector((state) => state.experience);

  const { listFieldsExperience } = useSelector((state) => state.moduleConfig);
  const { comparisonExperienceComboEnabled } = useSelector((state) => state.configuration);
  const [listFieldsToCompare, setListFieldsToCompare] = useState();
  const [selectedField, setSelectedField] = useState()

  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsExperience.forEach(element => {
      
      if (element.is_comparable) {
        
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  const handleChangeSelectCompare = (event) => {

    if (event != null) {
      setSelectedField(event);

      let selectedIds = "";
      let countIds = 0;
      for (let index = 0; index < experiencesS.length; index++) {
        if (experiencesS[index].isSelected) {
          experiencesS[index].isCompared = true;

          if (countIds === 0) {
              selectedIds = selectedIds.concat(experiencesS[index].id);
            } else {
              selectedIds = selectedIds.concat(";", experiencesS[index].id);
            }

            countIds++;

        }else{
          experiencesS[index].isCompared = false;
        }
      }

      const objectCompare = {
        deleted:false,
        compare_ids:selectedIds,
        total_selected:countIds,
        selected_field:event.field,
        is_compare_all_fields:false
      }
      dispatch(startRegisterCompareResult(objectCompare));


    } else {
      setSelectedField(null);
    }
  };


  return (
    <div>

      <div className="flexbox-title">
         <h2>{t("general.compare-experience")}</h2>
      </div>

      <br />

      {
        comparisonExperienceComboEnabled === "true" &&
        <div>
          <Select
            myFontSize="14px"
            onChange={(event) => handleChangeSelectCompare(event)}
            className={`basic-single form-control`}
            classNamePrefix="select"
            name="texto"
            options={listFieldsToCompare}
            getOptionLabel={(option) => t(`${option.module_text}.synthetic.${option.field}`)}
            getOptionValue={(option) => `${option}`}
            isClearable={true}
            isSearchable={true}
            placeholder="Seleccione un Campo para comparar"
          />

          {selectedField && selectedField.field &&
            (<TableVerticalExperience selectedField={selectedField} data={experiencesS} />)
          }

        </div>
      }

      <br />

    </div>
  )
}

export default ComparisonContainerExperienceByField